import { GaTrackingEventName, GATrackingEventType } from '../../constants';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEvent } from '../ga-tracking-event.model';

export class GaTrackingBackToCartEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.BackToCart;
  }

  getPayload(): GATrackingEventPayload {
    return {
      ...this.payload,
      event: GaTrackingEventName.Interaction,
      gtmCustom: {
        ...this.payload?.gtmCustom,
        action: 'Popup on checkout with invalid region offer'
      }
    };
  }
}
